import store from "../store";
import PageLayout from "@/views/Layout/PageLayout.vue";

// GeneralViews
import NotFound from "@/views/GeneralViews/NotFoundPage.vue";

// Pages
const Products = () =>
  import(/* webpackChunkName: "pages-products" */ "@/views/Pages/Products.vue");
const Product = () =>
  import(/* webpackChunkName: "pages-product" */ "@/views/Pages/Product.vue");
const Home = () =>
  import(/* webpackChunkName: "pages-home" */ "@/views/Pages/Home.vue");
const Artists = () =>
  import(/* webpackChunkName: "pages-artists" */ "@/views/Pages/Artists.vue");
const About = () =>
  import(/* webpackChunkName: "pages-about" */ "@/views/Pages/About.vue");
const SellDigitalArt = () =>
  import(
    /* webpackChunkName: "pages-sell-digital-art" */ "@/views/Pages/SellDigitalArt.vue"
  );
const ArtistProfile = () =>
  import(
    /* webpackChunkName: "pages-artistprofile" */ "@/views/Pages/ArtistProfile.vue"
  );
const ProfessionalDesignServices = () =>
  import(
    /* webpackChunkName: "pages-professionadesign" */ "@/views/Pages/ProfessionalDesignServices.vue"
  );
const Store = () =>
  import(/* webpackChunkName: "pages-store" */ "@/views/Pages/StoreV2.vue");
const MemberDashboard = () =>
  import(
    /* webpackChunkName: "pages-memberdashboard" */ "@/views/Pages/MemberDashboard.vue"
  );
const MyImages = () =>
  import(/* webpackChunkName: "pages-myimages" */ "@/views/Pages/MyImages.vue");
const Terms = () =>
  import(/* webpackChunkName: "pages-terms" */ "@/views/Pages/Terms.vue");
const PrivacyPolicy = () =>
  import(
    /* webpackChunkName: "pages-privacypolicy" */ "@/views/Pages/PrivacyPolicy.vue"
  );
const EmailPreferences = () =>
  import(
    /* webpackChunkName: "pages-email-preferences" */ "@/views/Pages/EmailPreferences.vue"
  );
const ArtistAgreement = () =>
  import(
    /* webpackChunkName: "pages-terms" */ "@/views/Pages/ArtistAgreement.vue"
  );
const Contact = () =>
  import(/* webpackChunkName: "pages-contact" */ "@/views/Pages/Contact.vue");
const Uses = () =>
  import(/* webpackChunkName: "pages-uses" */ "@/views/Pages/Uses.vue");
const Sell = () =>
  import(/* webpackChunkName: "pages-sell" */ "@/views/Pages/Sell.vue");
const Blog = () =>
  import(/* webpackChunkName: "pages-blog" */ "@/views/Pages/Blog.vue");
const Instagram = () =>
  import(
    /* webpackChunkName: "pages-instagram" */ "@/views/Pages/Instagram.vue"
  );
const Shop = () =>
  import(/* webpackChunkName: "pages-shop" */ "@/views/Pages/Shop.vue");
const BlogPost = () =>
  import(/* webpackChunkName: "pages-blogpost" */ "@/views/Pages/BlogPost.vue");
const MyCollections = () =>
  import(
    /* webpackChunkName: "pages-collections" */ "@/views/Pages/MyCollections.vue"
  );
const Collection = () =>
  import(
    /* webpackChunkName: "pages-collections" */ "@/views/Pages/Collection.vue"
  );
const Latest = () =>
  import(/* webpackChunkName: "pages-latest" */ "@/views/Pages/Latest.vue");
// const Notifications = () =>
//   import(
//     /* webpackChunkName: "pages-notifications" */ "@/views/Pages/Notifications.vue"
//   );

// Form Pages
const Login = () =>
  import(/* webpackChunkName: "pages-login" */ "@/views/Pages/Login.vue");
const CreateAccount = () =>
  import(
    /* webpackChunkName: "pages-createaccount" */ "@/views/Pages/CreateAccount.vue"
  );
// const Purchase = () =>
//   import(/* webpackChunkName: "pages-purchase" */ "@/views/Pages/Purchase.vue");
const Checkout = () =>
  import(/* webpackChunkName: "pages-checkout" */ "@/views/Pages/Checkout.vue");
const ForgotPassword = () =>
  import(
    /* webpackChunkName: "pages-forgotpassword" */ "@/views/Pages/ForgotPassword.vue"
  );
const ResetPassword = () =>
  import(
    /* webpackChunkName: "pages-resetpassword" */ "@/views/Pages/ResetPassword.vue"
  );

// Authenticated routes
const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next();
    return;
  }
  next("/");
};

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();
    return;
  }
  next({
    path: "/login",
    query: {
      nextUrl: to.fullPath,
    },
  });
};

let pages = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    component: About,
  },
  {
    path: "/sell-digital-art",
    name: "Sell Digital Art",
    component: SellDigitalArt,
  },
  {
    path: "/artists",
    name: "Artists",
    component: Artists,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
  },
  {
    path: "/uses",
    name: "Uses",
    component: Uses,
  },
  {
    path: "/sell",
    name: "Sell",
    component: Sell,
  },
  {
    path: "/terms",
    name: "Terms of Service",
    component: Terms,
  },
  {
    path: "/privacy-policy",
    name: "Privacy Policy",
    component: PrivacyPolicy,
  },
  {
    path: "/artistagreement",
    name: "Artist Agreement",
    component: ArtistAgreement,
  },
  {
    path: "/createaccount",
    name: "Create Account",
    component: CreateAccount,
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: "/forgotpassword",
    name: "Forgot Password",
    component: ForgotPassword,
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: "/resetpassword",
    name: "Reset Password",
    component: ResetPassword,
    beforeEnter: ifNotAuthenticated,
  },
  // {
  //   path: "/purchase",
  //   name: "Purchase",
  //   component: Purchase,
  //   beforeEnter: ifAuthenticated,
  // },
  {
    path: "/checkout",
    name: "Checkout",
    component: Checkout,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/store",
    name: "Store",
    component: Store,
  },
  {
    path: "/art/:artist",
    name: "Artist Profile",
    component: ArtistProfile,
  },
  {
    path: "/artist/:artist",
    name: "Artists Profile",
    component: ArtistProfile,
  },
  {
    path: "/blog",
    name: "Blog",
    component: Blog,
  },
  {
    path: "/instagram",
    name: "Instagram",
    component: Instagram,
  },
  {
    path: "/shop",
    name: "Shop",
    component: Shop,
  },
  {
    path: "/blog/:title",
    name: "Blog Post",
    component: BlogPost,
  },
  {
    path: "/art/:artist/:imageId?",
    name: "Image Product",
    component: Product,
  },
  {
    path: "/animation/:artist/:animationId?",
    name: "Animation Product",
    component: Product,
  },
  {
    path: "/products",
    name: "Products",
    component: Products,
  },
  {
    path: "/professional-design-services",
    name: "Professional Design Services",
    component: ProfessionalDesignServices,
  },
  {
    path: "/memberdashboard",
    name: "Member Dashboard",
    component: MemberDashboard,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/mycollections",
    name: "My Collections",
    component: MyCollections,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/emailpreferences",
    name: "Email Preferences",
    component: EmailPreferences,
    beforeEnter: ifAuthenticated,
  },
  // {
  //   path: "/notifications",
  //   name: "Notifications",
  //   component: Notifications,
  //   beforeEnter: ifAuthenticated,
  // },
  {
    path: "/user/:userId/collection/:collectionId?",
    name: "Collection",
    component: Collection,
  },
  {
    path: "/myimages",
    name: "My Images",
    component: MyImages,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/latest",
    name: "Latest",
    component: Latest,
  },
  { path: "*", component: NotFound, name: "Not Found" },
];

const routes = pages;

export default routes;
